import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import { IconTrash, IconCheck, IconClock } from "@tabler/icons-react";

const CartItem = ({
  item,
  count,
  update_item,
  remove_item,
  render,
  setRender,
  setAlert,
}) => {
  const [formData, setFormData] = useState({
    item_count: 1,
  });

  const { item_count } = formData;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState(null); // "update" o "remove"

  useEffect(() => {
    if (count) setFormData({ ...formData, item_count: count });
  }, [count]);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleUpdate = async () => {
    if (item.product.quantity >= item_count) {
      await update_item(item, item_count);
    } else {
      setAlert("No hay suficiente inventario", "danger");
    }
    setRender(!render);
    setIsModalOpen(false);
  };

  const handleRemove = async () => {
    await remove_item(item);
    setRender(!render);
    setIsModalOpen(false);
  };

  const openModal = (action) => {
    setModalAction(action);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalAction(null);
  };

  return (
    <>
      <li className="flex py-6 sm:py-10">
        <div className="flex-shrink-0">
          <img
            src={`${process.env.REACT_APP_API_URL}${item.product.get_thumbnail}`}
            alt=""
            className="w-24 h-24 rounded-md object-center object-cover sm:w-48 sm:h-48"
          />
        </div>

        <div className="ml-4 flex-1 flex flex-col justify-between sm:ml-6">
          <div className="relative pr-9 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:pr-0">
            <div>
              <div className="flex justify-between">
                <h3 className="text-sm">
                  <Link
                    to={`/product/${item.product.id}`}
                    className="font-medium text-gray-700 hover:text-gray-800"
                  >
                    {item.product.name}
                  </Link>
                </h3>
              </div>

              <p className="mt-1 text-sm font-medium text-gray-900">
                $ {item.product.price}
              </p>
            </div>

            <div className="mt-4 sm:mt-0 sm:pr-9">
              <select
                name="item_count"
                onChange={(e) => onChange(e)}
                value={item_count}
                className="max-w-full rounded-md border border-gray-300 py-1.5 text-base leading-5 font-medium text-gray-700 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              >
                {[...Array(10).keys()].map((num) => (
                  <option key={num + 1} value={num + 1}>
                    {num + 1}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={() => openModal("update")}
                className="ml-2 text-gray-400 hover:text-gray-500"
              >
                Actualizar
              </button>

              <div className="absolute top-0 right-0">
                <button
                  type="button"
                  onClick={() => openModal("remove")}
                  className="text-red-400 hover:text-red-500"
                >
                  <IconTrash size={20} />
                </button>
              </div>
            </div>
          </div>

          <p className="mt-4 flex text-sm text-gray-700 space-x-2">
            {item.product && item.product.quantity > 0 ? (
              <>
                <IconCheck
                  className="flex-shrink-0 h-5 w-5 text-green-500"
                  aria-hidden="true"
                />
                <span>Disponible</span>
              </>
            ) : (
              <>
                <IconClock
                  className="flex-shrink-0 h-5 w-5 text-gray-300"
                  aria-hidden="true"
                />
                <span>No Disponible</span>
              </>
            )}
          </p>
        </div>
      </li>

      {/* Modal */}
      <Transition appear show={isModalOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="fixed inset-0 bg-black opacity-75" />
          <div className="flex items-center justify-center min-h-screen px-4 text-center">
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-transform transform bg-white shadow-xl rounded-lg">
              <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900"
              >
                Confirmación
              </Dialog.Title>
              <div className="mt-4">
                <p className="text-sm text-gray-500">
                  {modalAction === "update"
                    ? "¿Estás seguro de que deseas actualizar la cantidad de este producto?"
                    : "¿Estás seguro de que deseas eliminar este producto del carrito?"}
                </p>
              </div>

              <div className="mt-6 flex justify-end space-x-4">
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                  onClick={closeModal}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
                  onClick={
                    modalAction === "update" ? handleUpdate : handleRemove
                  }
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default CartItem;
